/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Component for Basket button
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.0
 */
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { pushGTMAnalytic } from '../../../../../../modules/analytics/GoogleTagManager/GTMActions';
import GTMOperations from '../../../../../../modules/analytics/GoogleTagManager/GTMOperations';
import { IGTMPushAnalyticPayload } from '../../../../../../modules/analytics/GoogleTagManager/types/GTMActionTypes';
import { makeSelectTranslationCommon } from '../../../../../../modules/internationalization/intSelectors';
import ICommonTranslation from '../../../../../../modules/internationalization/types/common';
import { IRootReducer } from '../../../../../../reducers/rootReducer';
import { openBasket } from '../../../../actions/tableActions';
import { IOpenBasketActionPayload } from '../../../../types/tableTypes';
import { IBasketGTMProps } from '../basketTypes';
import { BasketButtonStyled } from './styled/BasketStyled';

interface IBasketProps {
    count: number | null;
    gtmProps?: IBasketGTMProps;
    title: string;
}

export type TBasketProps = IBasketProps & IConnectedProps & IDispatchProps;

export const Basket = (props: TBasketProps) => {
    const { checkedNum } = props.commonTranslation.basket;

    const openBasket = () => {
        props.openBasket({ title: props.title, gtmProps: props.gtmProps });
        if (props.gtmProps) props.pushGtmAnalytic({
            operation: GTMOperations.basket.onBasketButtonClick(props.gtmProps.sectionType),
            withAccountType: true,
            withSusrId: true,
            withUserRole: true,
        })
    };

    return (
        <BasketButtonStyled onClick={openBasket}>
            {`${checkedNum} ${props.count}`}
        </BasketButtonStyled>
    );
};

interface IConnectedProps {
    commonTranslation: ICommonTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    commonTranslation: makeSelectTranslationCommon(),
})

interface IDispatchProps {
    openBasket: (payload: IOpenBasketActionPayload) => void;
    pushGtmAnalytic: (payload: IGTMPushAnalyticPayload) => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    openBasket: (payload) => dispatch(openBasket(payload)),
    pushGtmAnalytic: (payload) => dispatch(pushGTMAnalytic(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Basket);
